import React from 'react';

const FeatureSection = () => {

  return (
    <>
        {/* feature-section */}
        <section className="feature-section p_relative">
            <div className="auto-container">
                <div className="inner-container p_relative d_block">
                    <div className="shape-layer" style={{backgroundImage: `url('assets/images/shape/shape-17.png')`}}></div>
                    <div className="title-box p_relative d_block centred">
                        <h2>Patient Care</h2>
                        <p>Sunshine Advanced Eye Care is recognized for its outstanding, comprehensive services for the diagnosis and treatment of all diseases of the eyes and related conditions.<br/> Our nurses, physicians, and staff are committed to providing high-quality medical care to every patient who walks through our doors. <br/>Because our patients’ convenience and comfort are top priorities, we place an emphasis on less invasive surgical techniques that offer improved success rates and shortened hospital stays.<br/> And with a number of children in our care, our specialists coordinate with support staff especially sensitive to the youngest patients and families.<br/> This blending of clinical excellence and personalized attention ensures our patients achieve the best possible long-term health.</p>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-3 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-one wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                <div className="inner-box p_relative d_block">
                                    <div className="icon-box p_relative d_block"><i className="icon-12"></i></div>
                                    <h3><a href="/">Qualified Doctors</a></h3>
                                    <p>Meet our team of highly qualified and experienced ophthalmologists dedicated to providing exceptional eye care.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-one wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                <div className="inner-box p_relative d_block">
                                    <div className="icon-box p_relative d_block"><i className="icon-13"></i></div>
                                    <h3><a href="/">Modern Equipment</a></h3>
                                    <p>Our state-of-the-art facility is equipped with the latest technology to ensure accurate diagnoses and precise treatments.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-one wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                <div className="inner-box p_relative d_block">
                                    <div className="icon-box p_relative d_block"><i className="icon-14"></i></div>
                                    <h3><a href="/">Emergency Help</a></h3>
                                    <p>Our emergency eye care services are available 24/7, providing immediate attention to any urgent eye conditions or injuries.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-one wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                                <div className="inner-box p_relative d_block">
                                    <div className="icon-box p_relative d_block"><i className="icon-15"></i></div>
                                    <h3><a href="/">Individual Approach</a></h3>
                                    <p>Our patient-centered approach ensures personalized care and tailored treatment plans to meet the unique needs of each individual.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* feature-section end */}
    </>
    );
  }
  
  export default FeatureSection;